import { SpaceBetween, tk, Typography } from '@sunwebgroup/ui-components'
import { Typography as TypographyUds } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

export const SwitchLabel = styled(TypographyUds)`
  ${TypographyUds.modVariant('body-m-regular-snug')}
  ${TypographyUds.modColor('semantics_content_color')}
`
export const RoomName = styled(Typography)`
  color: ${tk('color_semantic_text')};
`
export const ParticipantName = styled(TypographyUds)`
  ${TypographyUds.modVariant('display-h-regular')}
  ${TypographyUds.modColor('semantics_content_color')}
`
export const Price = styled(Typography)`
  color: ${tk('color_semantic_text_strong')};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;

  @media ${tk('mq_tablet')} {
    white-space: nowrap;
  }
`
export const Texts = styled(SpaceBetween)`
  flex: 1;
`
